import { orgHasAnsweredImportForks, orgShowsPayments, orgShowsSubcontractorPay, orgShowsTeam } from '@ruta/shared';
import { useOrganization } from './useQueries';

/**
 * Post-import fork visibility (RUT-3503). Answers live on firstRun (RUT-3501).
 * Existing orgs (no answers) keep every path. Only an explicit "no" hides
 * Team, sub pay, or payments.
 */
export function useImportForkVisibility() {
  const { data } = useOrganization();
  const org = data?.organization;
  return {
    importForks: orgHasAnsweredImportForks(org) ? org?.firstRun : undefined,
    showTeam: orgShowsTeam(org),
    showSubcontractorPay: orgShowsSubcontractorPay(org),
    showPayments: orgShowsPayments(org),
  };
}
